import { Container, Typography } from '@cleartrip/ct-design-components'
import ChevronDown from '@/assets/svg/ChevronDown'
import { FLIGHTS_AT_SAME_PRICE, HIDE, HIDE_OPTIONS_WITH_SAME_PRICE } from '@/constants/Srp'
import { motion } from 'framer-motion'
import React, { ReactNode, useEffect, useRef, useState } from 'react'
import ReactList from 'react-list'

interface SamePriceCardWrapperProps {
  children: ReactNode
  processedData: any
  card: any
  selectedSamePriceCard: number | null
  setSelectedSamePriceCard: (arg1: number | null) => void
  renderSingleJourneyCards: (
    cards: any[],
    index: number,
    key: React.Key | null | undefined,
    legNo: number,
    isHighRps?: boolean,
    type?: 'normal' | 'samePrice'
  ) => React.ReactElement
  setSelectedSamePriceCardList: (arg1: unknown[]) => void
  selectedSamePriceCardList: unknown[]
  type?: 'normal' | 'samePrice'
  isCfw?: boolean
}

const SamePriceCardWrapper: React.FC<SamePriceCardWrapperProps> = ({
  children = <></>,
  isCfw = false,
  processedData = {},
  card = {},
  selectedSamePriceCard = null,
  setSelectedSamePriceCard = (arg1: number | null) => {},
  renderSingleJourneyCards = (
    cards: any[],
    index: number,
    key: React.Key | null | undefined,
    legNo: number,
    isHighRps?: boolean,
    type?: 'normal' | 'samePrice'
  ) => <></>,
  setSelectedSamePriceCardList = (arg1: unknown[]) => {},
  selectedSamePriceCardList = [],
  type = 'normal',

}: SamePriceCardWrapperProps) => {
  const [scrollPos, setScrollPos] = useState(0)
  const isIntlOneWay = processedData?.isIntl && processedData?.tripType === 'oneway'
  const wrapSamePriceHandlings = isIntlOneWay && type === 'normal'
  const showSamePriceCard = selectedSamePriceCard === card?.cardId

  const handleHideSamePriceCard = () => {
    setSelectedSamePriceCard(null)
    setSelectedSamePriceCardList([])
    window.scrollTo({
      top: scrollPos,
      left: 0,
      behavior: 'smooth',
    })
  }

  const renderSamePriceCards = (index: number, key: React.Key | null | undefined) => {
    const result = renderSingleJourneyCards(selectedSamePriceCardList, index, key, 0, false, 'samePrice')
    return result || <div key={key}></div>
  }

  useEffect(() => {
    if (wrapSamePriceHandlings && showSamePriceCard) {
      setScrollPos(window.pageYOffset || document.documentElement.scrollTop || 0)
    } else {
      setScrollPos(0)
    }
  }, [showSamePriceCard, wrapSamePriceHandlings])

  if (!wrapSamePriceHandlings) {
    return <>{children}</>
  }

  return (
    <motion.div
    animate={showSamePriceCard ? 'open' : 'close'}
    className={`${showSamePriceCard ? 'my-4 br-12' : ''}`}
    initial={{ padding: 0 }}
    style={showSamePriceCard ? { background: isCfw ? '#F4EBFF' : '#F3F3F3' } : {}}
    transition={{
      duration: 0.4,
    }}
    variants={{
      open: {
        paddingTop: 12,
        paddingBottom: 8
      },
      close: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
      },
    }}
  >
    <Container className={showSamePriceCard ? 'mx-3' : ''}>
      {children}
      {showSamePriceCard && (
        <>
          <ReactList
            itemRenderer={renderSamePriceCards}
            length={selectedSamePriceCardList?.length}
            threshold={200}
            type='simple'
          />
          <Container className='flex flex-center c-pointer flex-middle mt-4 mb-2' onClick={handleHideSamePriceCard}>
            <Typography color='link' variant='L3'>
              {HIDE_OPTIONS_WITH_SAME_PRICE}
            </Typography>
            &nbsp;
            <Container
              style={{
                transform: 'rotate(180deg)',
                height: '18px',
                width: '20px',
              }}
            >
              <ChevronDown color='#0F6BFF' strokeWidth='1.5' />
            </Container>
          </Container>
        </>
      )}
    </Container>
  </motion.div>
  )
}

export default SamePriceCardWrapper
